import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { useQuery } from "@tanstack/react-query";
import { getMedal, getNocProfile } from "data/Querys";
import Loader from "components/general/Loader";
import NotAvailable from "components/common/NotAvailable";
import NocMedalsTable from "components/common/medals/NocMedalsTable";
import NocProfileTable from "components/common/participants/NocProfileTable";
import { usePreparePayLoad } from 'components/common/ocs-custom-events/helpers';
import FireOnContentLoadOCS from "components/general/FireOnContentLoadOCS";
import { useScrollToTop } from "helpers/utils";


export default function ProfilesByNoc() {
  const params = useUrlFriendlyToParameters()
  const { mirs_competition, mirs_language, mirs_noc } = params
  const payloadParams = usePreparePayLoad()
  useScrollToTop();

  //Get Data
  const { data, isError, isLoading } = useQuery({
    queryKey: ["medalTable", mirs_competition, mirs_language],
    queryFn: getMedal,
    refetchInterval: 5000,
  });

  const { data: dataNOC, isError: isErrorNOC, isLoading: isLoadingNOC } = useQuery({
    queryKey: ["nocTable", mirs_competition, "ENG", mirs_noc],
    queryFn: getNocProfile,
    refetchInterval: 5000,
  });

  let filterData = data?.medalNOC;
  filterData = filterData?.filter(item => item?.organisation?.code === mirs_noc);

  filterData = filterData?.filter(item => item?.sport === "GLO");
  
  if (isError || isErrorNOC) {
    return <NotAvailable label="LabelNoDataAvailable" />
  }

  if (isLoading || isLoadingNOC) {
    return <Loader />
  }

  if (!dataNOC?.nocBio) {
    return <NotAvailable label="LabelNoDataAvailable" />
  }

  return (
    <>
      <FireOnContentLoadOCS params={params} data={data} payloadParams={payloadParams} type={'byNoc'} />
      <NocMedalsTable data={filterData} key={`medallists`} />

      <NocProfileTable data={dataNOC} key={`nocProfile`} />
    </>
  )
}
